import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';

import {posApiRequest, posApiResponse} from '../lib/types';
import {posAPicall} from '../api/pos.api';
//import axios from 'axios';

const posApiData = {
  statusCode: '',
  message: '',
  storeId: '',
  orderId: '',
};

interface posState {
  posData: posApiResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: posState = {
  posData: posApiData,
  loading: false,
  error: '',
};

export const pushtoPoshOrder = createAsyncThunk(
  'employee/posorder',
  async (parameters: posApiRequest, thunkApi) => {
    return posAPicall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const posSlice = createSlice({
  name: 'pos',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetPosState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(pushtoPoshOrder.pending, state => {
      state.loading = true;
    });
    builder.addCase(pushtoPoshOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.posData = action.payload;
    });
    builder.addCase(pushtoPoshOrder.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetPosState} = posSlice.actions;

export const PosApiResponseData = (state: RootState): posApiResponse =>
  state.posReducer.posData;
export const errorInPosApi = (state: RootState): string =>
  state.posReducer.error;
export const PosApiLoading = (state: RootState): boolean =>
  state.posReducer.loading;

export default posSlice.reducer;
